// @vendors
import React, { useContext } from 'react'

// @helpers
import DynamicPagination from '../../../helpers/DynamicPagination'

// @context
import { FilePageContext } from '../FilePage';

const CustomPagination = () => {
    const { rowsState, setRowsState, fetchFiles } = useContext(FilePageContext);
  return (
    <DynamicPagination rowsState={rowsState} setRowsState={setRowsState} fetchData={fetchFiles}/>
  )
}

export default CustomPagination